import React from "react";
import MainLayout from "./MainLayout";
import ReferralProgram from "../common/MainContent/Home/ReferralProgram";

const ReferralProgramPage = (props) => <MainLayout component={ReferralProgram} />;

export default ReferralProgramPage;
